<template>
  <div class="klickbox-edit-code" v-if="step.kind === 'redirect'">
    <div class="klickbox-code-label">{{ $t('edit.canvas.redirect_url') }}</div>
    <input
      type="text"
      class="klickbox-code-input"
      @change="stepUpdateRedirectUrl({ event: $event, id: step.id })"
      v-bind:value="step.redirect_url">

    <div class="kp-modular-row clearfix">
      <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.auto_redirect') }}</label>
      <div class="kp-modular-check pull-right kp-modular-check-without-icon">
        <input type="checkbox" @change="stepUpdateRedirectAutomatic({ event: $event, id: step.id })" v-bind:checked="step.redirect_automatic"><span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    step: 'stepActive',
  }),
  methods: mapActions([
    'stepUpdateRedirectAutomatic',
    'stepUpdateRedirectUrl',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Redirect.vue?c88076c2
 **/